module.exports = __webpack_public_path__ + "img/pin.b010b41e.png";